<template>
	<TheHeader></TheHeader>

	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>

					<ThePageLoading v-if="isPageLoading"></ThePageLoading>

					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deleteJournal" @import-event="importFile" @export-event="exportFile" :renderDelete="(!isViewer && identifier != null ? true : false)" :renderImport="(!isViewer && journal.status == 'Created' ? true : false)" :renderExport="(!isViewer && journal.status != '' ? true : false)" :isDeleting="isDeleting" :isImporting="isImporting" :isExporting="isExporting" ></ThePageHeader>

						<div class="row" v-if="pageError == ''">							
							<div class="col-md-12 p-4">
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Conso Group:</label>
									</div>

									<div class="col-md-6">
										<Dropdown :options="consoGroups" optionLabel="name" optionValue="identifier" filter :filterFields="['name']" showClear :placeholder="isConsoGroupLoading ? ('Loading...') : '-- Please Select --'" :loading="isConsoGroupLoading" v-model="journal.consoGroup.identifier" :disabled="identifier != null"></Dropdown>
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Balance Sheet Date:</label>
									</div>

									<div class="col-md-6">
										<Calendar dateFormat="yy-mm-dd" :manualInput="true" placeholder="Balance Sheet Date" v-model="journal.balanceSheetDate" :disabled="identifier != null" />
									</div>
								</div>

								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-12">
										<Divider type="solid"></Divider>
									</div>
								</div>
								
								<div v-if="identifier != null">
									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Consolidated By:</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="journal.submissionBy" readonly />
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">Consolidated Date:</label>
										</div>

										<div class="col-md-3" >
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="journal.submissionDate" readonly />
										</div>
									</div>

									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Status:</label>
										</div>

										<div class="col-md-6" style="padding: 0.5rem 1rem;">
											<Badge class="mr-2" :class="[journal.status == 'Consolidated' ? 'p-badge-success' : 'p-badge-warning']" :value="journal.status"></Badge>
										</div>
									</div>		
								</div>

								<div class="row mb-3" v-if="identifier != null">
									<Divider />
								</div>
								
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-5 d-flex align-items-center">
										<Button class="p-button-sm" @click="addJournalEntity" label="Add Journal Entity" :disabled="journal.status == 'Consolidated'" :hidden="isViewer" />
										<span class="p-1"></span>
										<Button class="p-button-sm" @click="showCarryForwardDialog()" label="Create Carry Forward Journal" :hidden="isViewer" />
									</div>
								</div>
								
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-12">
										<DataTable :value="journal.journalEntities" responsiveLayout="scroll" selectionMode="row" sortField="id" :sortOrder="1" paginator :rows="10" paginatorPosition="top" @rowClick="viewJournalEntity">
											<Column style="width: 15%" field="id" header="ID" :sortable="true"></Column>
											<Column style="width: 15%" field="companyCode" header="Entity" sortable></Column>
											<Column style="width: 60%" field="description" header="Description" sortable></Column>
											<Column style="width: 10%" header="">
												<template #body="slotProps">
													<Button icon="pi pi-trash" severity="danger" text rounded @click="removeJournalEntity(slotProps.data)" title="Delete" :disabled="journal.status == 'Consolidated'" :hidden="isViewer" />
												</template>
											</Column>
											
											<template #empty>
												<div class="error-no-record" v-if="journal.journalEntities.length <= 0">
													<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
													<h6><span>No Record Found</span></h6>
												</div>
											</template>
										</DataTable>
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3"></div>

									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.journal.$invalid || isLoading" @click="showSaveConfirmationDialog()" label="Save" v-if="identifier == null" />
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
										<span class="p-1"></span>

										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>

					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>

	<Dialog v-model:visible="isShowConfirmation" header="Create from Previous Journal" modal :style="{ width: '50vw' }">
		<p>
			Do you want to create a new journal from previous journal?
		</p>

		<DataTable class="p-datatable p-component align-middle mb-0 w-12" :value="previousJournals" v-model:selection="selectedJournal" paginator :rows="5">
			<Column style="width: 10%" selectionMode="single"></Column>
			<Column style="width: 65%;" field="fileId" header="File ID"></Column>
			<Column style="width: 25%;" field="balanceSheetDate" header="Balance Sheet Date"></Column>
		</DataTable>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="save(false)" text />
			<span class="p-1"></span>
			<Button label="Yes" icon="pi pi-check" @click="save(true)" :disabled="v$.selectedJournal.$invalid || isLoading"  />
		</template>
	</Dialog>

	<Dialog v-model:visible="isShowCarryForward" header="Create Carry Forward Journal" modal :style="{ width: '50vw' }">
		<p>
			Do you want to create a new carry forward journal?
		</p>

			<div class="row mb-3">
				<div class="col-md-3 required">
					<label class="col-form-label-title">Conso Group:</label>
				</div>

				<div class="col-md-6">
					<Dropdown :options="consoGroups" optionLabel="name" optionValue="identifier" filter :filterFields="['name']" showClear :placeholder="isConsoGroupLoading ? ('Loading...') : '-- Please Select --'" :loading="isConsoGroupLoading" v-model="carryForwardJournal.consoGroup.identifier" ></Dropdown>
				</div>
			</div>

			<div class="row mb-3">
				<div class="col-md-3 required">
					<label class="col-form-label-title">Balance Sheet Date:</label>
				</div>

				<div class="col-md-6">
					<Calendar dateFormat="yy-mm-dd" :manualInput="true" placeholder="Balance Sheet Date" v-model="carryForwardJournal.balanceSheetDate"/>
				</div>
			</div>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="saveCarryForwardJournal(false)" text />
			<span class="p-1"></span>
			<Button label="Yes" icon="pi pi-check" @click="saveCarryForwardJournal(true)" :disabled="v$.carryForwardJournal.$invalid || isLoading"  />
		</template>
	</Dialog>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import journalApi from "@/api/journal-api";
	import journalEntityApi from "@/api/journalentity-api";
	import consoGroupApi from "@/api/consogroup-api";
	import roleMixin from "@/mixin/role";
	import statusMixin from "@/mixin/status";
	import dateUtilsMixin from "@/mixin/utils/date-utils";

	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	import useVuelidate from "@vuelidate/core"
	import { required, requiredIf } from "@vuelidate/validators"
	
	export default defineComponent({
		mixins:[roleMixin, statusMixin, dateUtilsMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				journal: {identifier: null, consoGroup: {identifier: null, name: ''} as any, consoGroupName: null, balanceSheetDate: null as any, journalEntities: [] as any[], submissionBy: '', submissionDate: '', status: '', previousJournalId: null, isClosed: false},
				consoGroups: [] as any[],
				previousJournals: [] as any[],
				selectedJournal: null as any,
				carryForwardJournal: {identifier: null, consoGroup: {identifier: null, name: ''} as any, consoGroupName: null, balanceSheetDate: null as any, journalEntities: [] as any[], submissionBy: '', submissionDate: '', status: '', previousJournalId: null, isClosed: false},
				isConsoGroupLoading: false,
				isPageLoading: false,
				isLoading: false,
				isExporting: false,
				isImporting: false,
				isDeleting: false,
				isShowConfirmation: false,
				isShowCarryForward: false,
				journalReport: {},
			}
		},
		watch: {
			filterLegalGroup(newValue: any) {
				if (this.identifier == null) {
					this.isConsoGroupLoading = true;
					consoGroupApi.consoGroupList({value: newValue})
						.then(response => {
							this.consoGroups = response.data.listSet;
							this.isConsoGroupLoading = false;
						})
						.catch(error => {
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							this.isConsoGroupLoading = false;
						})
				}
			}
		},
		computed: {
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			}
		},
		mounted: function () {
			if (this.pageError == '') {
				this.isPageLoading = true;
	
				let r1 = consoGroupApi.consoGroupList({value: this.filterLegalGroup});

				let r2 = null;
				if (this.identifier != null) {
					r2 = journalApi.journalView(this.identifier)
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}
	
				Promise.all([r1, r2])
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == 0) {
												this.consoGroups = values[i].data.listSet;
											}
											else if (i == 1) {
												this.journal = values[i].data.journal;
												if (this.journal != null && this.journal.balanceSheetDate != null) {	
													this.journal.balanceSheetDate = this.formatToDate(this.journal.balanceSheetDate);
												}
												if (this.journal.submissionDate != null && this.journal.submissionDate != '') {
													this.journal.submissionDate = this.formatToDateTime(this.journal.submissionDate);
												}
											}
										}
									}
								}
							}
						}
						this.isPageLoading = false;
					})
					.catch(error => {
						this.isPageLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			}
		},
		methods: {
			showSaveConfirmationDialog() {
				this.isLoading = true;
				
				this.previousJournals = [] as any[];
				if (this.journal.balanceSheetDate != null && (this.journal.balanceSheetDate instanceof Date)) {
					this.journal.balanceSheetDate = this.formatToDate(this.journal.balanceSheetDate);
				}
				journalApi.journalListByPreviousJournal({journal: this.journal})
					.then((response: any) => {
						this.isLoading = false;
						if (response.data.listSet.length != 0) {
							this.previousJournals = response.data.listSet;
							this.isLoading = false;
							
							this.isShowConfirmation = true;
						}
						
						else {
							this.isShowConfirmation = false;
							this.save(false);
						}
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			showCarryForwardDialog() {
				this.isShowCarryForward = true; 
				this.carryForwardJournal.consoGroup.identifier = this.journal.consoGroup.identifier;
			},
			save(isPreviousJournal: boolean) {
				this.isLoading = true;
				
				if (this.journal.balanceSheetDate != null && (this.journal.balanceSheetDate instanceof Date)) {
					this.journal.balanceSheetDate = this.formatToDate(this.journal.balanceSheetDate);
				}

				this.journal.previousJournalId = (isPreviousJournal == true ? this.selectedJournal.identifier : null)
				journalApi.journalSave({
						journal: this.journal
					})
					.then(response => {
						this.isLoading = false;
						// After a successful create, go to the new journal's edit details page (not the list).
						this.$router.push("/journal/" + response.data.journal.identifier);
					})
					.catch((error) => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			saveCarryForwardJournal(isPreviousJournal: boolean){
				this.isLoading = true;

				if (this.carryForwardJournal.balanceSheetDate != null && (this.carryForwardJournal.balanceSheetDate instanceof Date)) {
					this.carryForwardJournal.balanceSheetDate = this.formatToDate(this.carryForwardJournal.balanceSheetDate);
				}

				this.carryForwardJournal.previousJournalId = (isPreviousJournal == true ? this.journal.identifier : null)
				journalApi.journalSaveCarryForward({
					journal: this.carryForwardJournal
				})
				.then((response: any) => {
					this.isLoading = false;
					this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
					// After a successful carry-forward create, go to the new journal's edit details page.
					this.$router.push("/journal/" + response.data.journal.identifier);
				})
				.catch((error) => {
					this.isLoading = false;
					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
				})

			}, 
			addJournalEntity() {
				this.$router.push("/journal/" + this.identifier + "/add");
			},
			viewJournalEntity(event: any) {
				this.$router.push(`/journal/` + this.identifier + `/view/` + event.data.identifier);
			},
			removeJournalEntity(journalEntity: any) {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to delete this journal?',
					icon: 'pi pi-trash',
					accept: () => {
						let index = this.journal.journalEntities.findIndex((e: any) => {
							return e.identifier == journalEntity.identifier
						});

						journalEntityApi.journalEntityDelete(this.journal.journalEntities[index].identifier)
							.then((response:any)=>{
								this.journal.journalEntities.splice(index,1);
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
							})
							.catch((error)=>{
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})

					}
				});
			},
			cancel(){
				this.$router.push("/journal");
			},
			deleteJournal() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this journal?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isExporting = true;
						journalApi.journalExport({identifier: this.journal.identifier, actionType: "backup", backupAction: "DEL"})
							.then(response => {
								this.isExporting = false;
								this.isDeleting = true;
								journalApi.journalDelete({
										journal: this.journal
									})
									.then((response: any) => {
										store.getters.getCached.page = null;
										this.isDeleting = false;
										this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
										this.$router.push("/journal");
									})
									.catch(error => {
										this.isDeleting = false;
										this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
									})
							})
							.catch(error => {
								this.isExporting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							});						
					}
				})
			},
			importFile(file: any) {
				this.isExporting = true;
				this.isImporting = true;
				
				journalApi.journalExport({identifier: this.journal.identifier, actionType: "backup", backupAction: "IMP"})
					.then(response => {
                        this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
						this.isExporting = false;
						
						var formData = new FormData();
						formData.append('file', file[0]);

						journalApi.journalImport(formData, this.journal.identifier)
							.then((response: any) => {
								this.isImporting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								journalApi.journalView(this.identifier)
									.then((response: any) => {
										this.journal = response.data.journal;
									})
									.catch(error => {
										this.pageError = error;
									});
							})
							.catch(error => {
								this.isImporting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							});
					})
					.catch(error => {
						this.isImporting = false;
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			exportFile() {
				this.isExporting = true;
				journalApi.journalExport({identifier: this.journal.identifier, actionType: "manual"})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			}
		},
		setup() {
				return {v$: useVuelidate()}
		},
		validations() {
			return {
				journal: {
					consoGroup: {
						identifier: {
							required: requiredIf(this.identifier == null)
						},
					},
					balanceSheetDate: {
						required
					},
					isClosed: {
						required
					},
				},
				selectedJournal: {
					required: requiredIf(this.isShowConfirmation),
				},
				carryForwardJournal: {
					consoGroup: {
						identifier: {
							required: requiredIf(this.identifier == null)
						},
					},
					balanceSheetDate: {
						required
					},
					isClosed: {
						required
					},
				}
			}
		}
	})
</script>